import Managements from './Managements';

export default Managements;
